const $sliders = $('.js-caption-slider');

const captionSlider = {
  initialize() {
    if (!$sliders.length) {
      return;
    }

    this.createEventListeners();
  },

  createEventListeners() {
    $sliders.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
      const count = `${nextSlide + 1} / ${slick.slideCount}`;

      slick.$slider.find('.js-caption-count').text(count);
    });
  },
};

export default captionSlider;
